export function kliknalPrzyciskZobaczPasujaceProduktyWZastosowaniu() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest(
            '[data-ga-event-kliknal-przycisk-zobacz-pasujace-produkty-w-zastosowaniu]'
        );
        if (!target) return;

        window.dataLayer = window.dataLayer || [];

        const productsType =
            target
                .closest('.section-box')
                ?.querySelector('.section-box__title')
                ?.textContent.trim() || '';

        const application =
            document.querySelector('#hero-title')?.textContent.trim() || '';

        const currentUrl = window.location.origin
            + window.location.pathname
            + window.location.search;

        window.dataLayer.push({
            event: 'kliknal_przycisk_zobacz_pasujace_produkty_w_zastosowaniu',
            products_type: productsType,
            application: application,
            application_url: currentUrl,
        });
    });
}
